import { Amplify } from 'aws-amplify';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-2_AoGLH7rjp',
      userPoolClientId: '1rkof3sscdns6683ceu7pd4o4t',
      signUpVerificationMethod: 'code' as const,
      loginWith: {
        email: true,
      },
    },
  },
};

Amplify.configure(awsConfig);

export default awsConfig;